import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
} from '@material-ui/core';
import { useOnMount } from 'utils/react';
import { MappingForm } from './MappingForm';
import { makeStyles } from '@material-ui/styles';
import ButtonsForm from 'ui/form/ButtonsForm';

const useStyles = makeStyles(theme => ({
    content: {
        margin: `${theme.spacing(2)}px 0px`,
    },
}));

export const MappingDialog = ({
    rowData,
    lookups,
    config,
    service,
    onSave,
    onCancel,
}) => {
    const classes = useStyles();
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(false);

    useOnMount(() => {
        const { external_company, external_agreement } = rowData;
        if (!!external_company && !!external_agreement) {
            setValues({
                company: {
                    label: lookups.external_company[external_company],
                    value: external_company,
                },
                agreement: {
                    label: lookups.external_agreement[external_agreement],
                    value: external_agreement,
                },
            });
        }
    });

    const handleChange = value => {
        if (value.company) {
            setValues(value);
            return;
        }
        setValues({ ...values, ...value });
    };

    const handleSave = () => {
        setLoading(true);
        onSave(values, rowData);
    };

    return (
        <Dialog open fullWidth>
            <DialogTitle>Company mapping: {rowData.company_name}</DialogTitle>
            <Divider />
            <DialogContent>
                <div className={classes.content}>
                    <MappingForm
                        config={config}
                        service={service}
                        values={values}
                        onChange={handleChange}
                        lookups={lookups}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <ButtonsForm.BackButton onClick={onCancel} />
                <ButtonsForm.NextButton
                    onClick={handleSave}
                    loading={loading}
                    disabled={!values.company || !values.agreement}
                    label="Save"
                />
            </DialogActions>
        </Dialog>
    );
};
